import { TitleCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { VerificacionService } from 'src/app/comun/services/verificacion.service';
import { MicroempresarioService } from '../../services/microempresario.service';
import { ParametrosService } from '../../../services/parametros.service';
import { PasswordService } from '../../services/password.service';
import { PersonaNatural } from '../../models/persona-natural';
import { SweetAlertService } from '../../../services/sweet-alert.service';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { NumeroDocumentoService } from '../../services/numero-documento.service';
import { Localidad } from 'src/app/comun/models/localidad';
import { LOCALIDADES_BOGOTA } from 'src/app/comun/data/localidades-bogota';
import {
  numeroDocumentoPorTipoDocValidator,
  getDocumentPatternMessage,
} from 'src/app/shared/utils/form-validators.util';
import { formatPesosCop, parsePesosCop } from 'src/app/shared/utils/currency-cop.util';
import { Constantes } from 'src/app/comun/data/constantes';
import { PASSWORD_COMPLEXITY_PATTERN } from 'src/app/shared/utils/validation.constants';
//jQuery
declare var $: any;

@Component({
    selector: 'formulario-persona-natural',
    templateUrl: './formulario-natural.html',
    providers: [TitleCasePipe],
    standalone: false
})
export class FormularioPersonaNatural implements OnInit {
  //Selects
  departamentos: any[] = [];
  ciudades: any[] = [];
  generos: any[];
  documentos: any[];
  ciius: any[];
  anios: any[];
  listaTiposCont: any[];
  //Fin selects
  isVisible: boolean = false;
  isConfirm: boolean = false;
  titleModal: string = 'P';
  validarContrasena = PASSWORD_COMPLEXITY_PATTERN;
  fuentesInformacion:any[];
  isReferido:boolean=false;
  isOtraFuente:boolean=false;
  paises: any[] = [];
  isPasaporte:boolean=false;
  idPaisOrigen:number;
  ventasMinimas:number=0;
  msjErrorValorVentas:string=null;
  /** Lista de dominios de correo no permitidos (PAR-160), cargada desde el back. */
  dominiosCorreoBloqueados: string[] = [];
  readonly idBogota = 11001;
  private static readonly PAR_DOMINIOS_CORREO_BLOQUEADOS = 'PAR-160';
  localidades: ReadonlyArray<Localidad> = LOCALIDADES_BOGOTA;
  currentStep = 1;
  readonly totalSteps = 2;
  private readonly step1Fields: string[] = [
    'primerNombre',
    'primerApellido',
    'idTipoDocIdentidad',
    'numeroDocumento',
    'confirmNumeroDocumento',
    'idGenero',
    'numeroCelular',
    'correoElectronico',
    'tieneRUT',
    'idFuenteNeocredito',
  ];
  private readonly step2Fields: string[] = [
    'idDepartamento',
    'idCiudad',
    'codigoCiiu',
    'anioVentas',
    'valorVentas',
    'tiposContacto',
    'minoria',
    'tratamientoDatos',
    'terminosCondiciones',
  ];
  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly _microempresario: MicroempresarioService,
    private readonly _password: PasswordService,
    private readonly _numeroDocumento: NumeroDocumentoService,
    private readonly _parametro: ParametrosService,
    private readonly route: Router,
    private readonly _verificacion: VerificacionService,
    private readonly router: ActivatedRoute,
    private readonly _sweetAlert:SweetAlertService,
    public readonly title: TitleCasePipe,
    private readonly _bancoldexService: BancoldexService,
  ) { }

  public naturalForm = this.formBuilder.group(
    {
      idEmpresario: null,
      idEmpresarioNatural: null,
      idUsuario: null,
      primerNombre: ['', Validators.required],
      segundoNombre: [''],
      primerApellido: ['', Validators.required],
      segundoApellido: [''],
      idGenero: ['', Validators.required],
      idTipoDocIdentidad: ['', Validators.required],
      numeroDocumento: [
        '',
        [
          Validators.required,
          numeroDocumentoPorTipoDocValidator(() => this.documentos, 'idTipoDocIdentidad'),
        ],
      ],
      confirmNumeroDocumento: [
        null,
        [
          Validators.required,
          numeroDocumentoPorTipoDocValidator(() => this.documentos, 'idTipoDocIdentidad'),
        ],
      ],
      numeroCelular: ['', Validators.required],
      idDepartamento: ['', [ Validators.required,Validators.min(1)]],
      idCiudad: ['', [ Validators.required,Validators.min(1)]],
      idLocalidad: [''],
      codigoCiiu: ['', Validators.required],
      correoElectronico: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,4}$'),
        ],
      ],
      anioVentas: ['', Validators.required],
      valorVentas: ['', Validators.required],
      contrasena: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(this.validarContrasena),
        ],
      ],
      confirmPassword: ['', Validators.required],
      tratamientoDatos: [false, [Validators.required, Validators.requiredTrue]],
      terminosCondiciones: [
        false,
        [Validators.required, Validators.requiredTrue],
      ],
      ciiuNombre: '',
      tieneRUT: ['', Validators.required],
      minoria:['', Validators.required],
      minoriaDescripcion:[''],
      idFuenteNeocredito: ['', Validators.required],
      nombreReferido: [''],
      codigoReferido: [''],
      otraFuente: [''],
      numeroOpcional:[''],
      idPaisOrigen:[''],
      tiposContacto: ['', Validators.required],
      camaraComercioVigente: ['']
    },
    {
      validator: [
        this._password.matchPassword('contrasena', 'confirmPassword'),
        this._numeroDocumento.matchPassword('numeroDocumento', 'confirmNumeroDocumento'),
        this.validarReferidoObligatorio()
      ]
    }
  );

  ngOnInit() {
    this.getActividades();
    this.getGeneros();
    this.getDocumentos();
    this.setPipeForm();
    this.getAnios();
    this.getPaises();
    this.getDepartamentos();
    this.getParametroValorMinVentas();
    this.getParametroDominiosCorreoBloqueados();
    this.getListaTiposContacto();
    this.naturalForm.get('idTipoDocIdentidad')?.valueChanges?.subscribe(() => {
      this.naturalForm.get('numeroDocumento')?.updateValueAndValidity();
      this.naturalForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
    });
    // Al digitar en numeroDocumento, revalidar coincidencia para mostrar "no coinciden" de inmediato
    this.naturalForm.get('numeroDocumento')?.valueChanges?.subscribe(() => {
      this.naturalForm.updateValueAndValidity({ emitEvent: false });
    });
    this.naturalForm.get('tieneRUT')?.valueChanges.subscribe((valor: string) => {
      this.naturalForm.get('idFuenteNeocredito')?.setValue('');
      this.isReferido = false;
      this.isOtraFuente = false;
      if (valor) {
        this.getFuentes(valor);
      }
    });
    this.naturalForm.get('minoria')?.valueChanges.subscribe((valor: number) => {
      this.validarMinoria(Number(valor));
    });
    this.loadData();
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 1000);
  }

  //Cargar selects
  getGeneros() {
    this._parametro.getGeneros().subscribe((data: any) => {
      if (data) {
        this.generos = data;
      }
    });
  }

  getDocumentos() {
    this._parametro.getTipoDocumentos().subscribe((data: any) => {
      if (data) {
        this.documentos = data.filter(
          (documento: any) =>
            documento.personaJuridica == 0 &&
            documento.idTipoDocIdentidad != 4 &&
            documento.idTipoDocIdentidad != 6
        );
        // Revalidar número de documento cuando ya hay tipos cargados (como en mrvfront)
        this.naturalForm.get('numeroDocumento')?.updateValueAndValidity();
        this.naturalForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
      }
    });
  }

  getActividades() {
    this._parametro.getCiius().subscribe((data: any) => {
      if (data.data) {
        this.ciius = data.data;
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        };
      }
    });
  }

  getAnios() {
    this._parametro
      .getAnios('natural')
      .subscribe((data: any) => {
        if (data.anios) {
          this.anios = data.anios;
          this.anios = this.anios.filter(anio => anio != new Date().getFullYear()-2 &&  anio != new Date().getFullYear());
          // Precargar primera opción por defecto cuando no se tenga data del usuario (HU)
          if (this.anios?.length > 0 && !this.naturalForm.get('anioVentas').value) {
            this.naturalForm.get('anioVentas').setValue(this.anios[0]);
          }
        }
      });
  }

  getDepartamentos() {
    this._parametro
      .getDepartamentos('169')
      .subscribe(
        (data: any) => (this.departamentos = data.data),
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'Error al cargar los departamentos');
        },
        () => {
          setTimeout(() => {
            $('#idCiudad').prop('disabled', true);
            $('.selectpicker').selectpicker('refresh');
          }, 500);
        }
      );
  }

  getPaises(){
    this._parametro
      .getPaises()
      .subscribe((data: any) => (this.paises = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los paises');
      });
  }

  getCambio(i: any) {
    this.selectpikerChange('idDepartamento');
    this.naturalForm.get('idCiudad').setValue('');
    $('.selectpicker').selectpicker('refresh');
    const idDepto = i?.target?.value;
    if (idDepto && idDepto !== '' && Number(idDepto) > 0) {
      this.getCiudades(Number(idDepto));
    } else {
      $('#idCiudad').prop('disabled', true);
      $('.selectpicker').selectpicker('refresh');
    }
  }

  getCiudades(idDepartamento: number) {
    this._parametro
      .getCiudades(idDepartamento.toString())
      .subscribe(
        (data: any) => (this.ciudades = data.data),
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'Error al cargar las ciudades');
        },
        () => {
          setTimeout(() => {
            $('#idCiudad').prop('disabled', false);
            $('.selectpicker').selectpicker('refresh');
          }, 500);
        }
      );
  }

  getFuentes(valor: string) {
    const filtro = {
      tiposPersona: [
        {
          idTipoPersonaJuridica: valor == Constantes.VALOR_SI
            ? Constantes.TIPO_PERSONA.NATURAL_FORMAL
            : Constantes.TIPO_PERSONA.NATURAL_INFORMAL
        }
      ]
    };
    this._microempresario.getFuentes(filtro).subscribe((response: any) => {
      if (response.exitoso) {
        this.fuentesInformacion = response.fuentes;
      } else {
        this._sweetAlert.errorModal("Error", true, "Error al cargar las fuentes de información")
      }
    },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'Error al cargar las fuentes de información');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        }, 300);
      });
   }

   getParametroValorMinVentas() {
    var json = {
      idParametro: 'PAR-118',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.ventasMinimas = Number(respuesta[0].valorParametro);
        this.validarVentaAnual();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  /** Carga PAR-160 (dominios de correo bloqueados) y aplica validador al campo correo. */
  getParametroDominiosCorreoBloqueados() {
    const json = {
      idParametro: FormularioPersonaNatural.PAR_DOMINIOS_CORREO_BLOQUEADOS,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        const data = response['data'];
        if (data && data[0] && data[0].valorParametro) {
          const valor = String(data[0].valorParametro).trim();
          this.dominiosCorreoBloqueados = valor
            .split(',')
            .map((d: string) => d.trim().toLowerCase())
            .filter((d: string) => d.length > 0);
        }
        this.agregarValidadorDominioCorreo();
      },
      () => {
        this.agregarValidadorDominioCorreo();
      }
    );
  }

  private agregarValidadorDominioCorreo() {
    const control = this.naturalForm.get('correoElectronico');
    if (!control) return;
    const validadores = [
      Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9-]+(?:\\.[a-z0-9-]+)*\\.[a-z]{2,4}$'),
      this.dominioCorreoBloqueadoValidator(),
    ];
    control.setValidators(validadores);
    control.updateValueAndValidity({ emitEvent: false });
  }

  private dominioCorreoBloqueadoValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value == null || String(value).trim() === '') return null;
      const idx = String(value).lastIndexOf('@');
      if (idx <= 0 || idx === String(value).length - 1) return null;
      const dominio = String(value).substring(idx + 1).trim().toLowerCase();
      if (this.dominiosCorreoBloqueados.length === 0) return null;
      if (this.dominiosCorreoBloqueados.includes(dominio)) {
        return { dominioCorreoBloqueado: true };
      }
      return null;
    };
  }

  /** Mensaje de error para correo electrónico (requerido, formato, dominio bloqueado). */
  getCorreoElectronicoErrorMessage(): string {
    const c = this.naturalForm.get('correoElectronico');
    if (!c?.errors) return '';
    if (c.hasError('required')) return 'Campo obligatorio';
    if (c.hasError('dominioCorreoBloqueado')) {
      return 'No está permitido el uso de correos temporales o de dominios no válidos para el registro.';
    }
    if (c.hasError('pattern')) return 'El correo electrónico no tiene una estructura válida (ej: correo@dominio.com).';
    return 'Correo electrónico no válido';
  }

  getListaTiposContacto(){
    this._microempresario.getListaTipoContacto().subscribe((resp: any) =>{
      this.listaTiposCont = resp;
    },
    (error) => {
      this._sweetAlert.errorModal("Error!",true,error.error);
    });
  }
  //Fin cargar selects

  loadData() {
    const idCampania = !this.router.snapshot.params.id
    ? null
    : this.router.snapshot.params.id;
  const token = !this.router.snapshot.params.token
    ? null
    : this.router.snapshot.params.token;
    const usuario: any = JSON.parse(sessionStorage.getItem('pre-registro'));
    if (usuario) {
      this._microempresario
        .cargarDatosRegistro('cargarRegistroNatural', usuario.idUsuario)
        .subscribe((data: any) => {
          if (data.microempresario) {
            this.loadFields(data.microempresario);
          }
        });
    } else if (idCampania && token){
      this._microempresario.cargarRegistroNatural({idCampania, token}).subscribe((response: any) => {
        if(response.exitoso){
          this.loadFields(response.data);
        }else{
          this._sweetAlert.errorModal("Error!",true,response.error);
        }
      });
    }
  }

  loadFields(empresario: any) {
    this.naturalForm.get('idEmpresario').setValue(empresario.idEmpresario);
    this.naturalForm.get('idEmpresarioNatural').setValue(empresario.idEmpresarioNatural);
    this.naturalForm.get('idUsuario').setValue(empresario.idUsuario);
    this.naturalForm.get('primerNombre').setValue(empresario.primerNombre);
    this.naturalForm.get('segundoNombre').setValue(empresario.segundoNombre);
    this.naturalForm.get('primerApellido').setValue(empresario.primerApellido);
    this.naturalForm.get('segundoApellido').setValue(empresario.segundoApellido);
    this.naturalForm.get('idGenero').setValue(empresario.idGenero);
    this.naturalForm.get('numeroCelular').setValue(empresario.numeroCelular);
    if (empresario.idDepartamento != null && empresario.idDepartamento != 0) {
      this.naturalForm.get('idDepartamento').setValue(empresario.idDepartamento);
      $('#idDepartamento').selectpicker('val', Number(empresario.idDepartamento));
      this.getCiudades(empresario.idDepartamento);
      this.naturalForm.get('idCiudad').setValue(empresario.idCiudad);
      $('#idCiudad').selectpicker('val', Number(empresario.idCiudad));
      if (empresario.idCiudad == this.idBogota && empresario.idLocalidad != null) {
        this.naturalForm.get('idLocalidad').setValue(empresario.idLocalidad);
        $('#idLocalidad').selectpicker('val', Number(empresario.idLocalidad));
      } else {
        this.naturalForm.get('idLocalidad').setValue(null);
      }
      this.validarLocalidad();
    }
    this.naturalForm.get('tiposContacto').setValue(empresario.tiposContacto);
    this.naturalForm.get('minoria').setValue(empresario.minoria);
    this.naturalForm.get('minoriaDescripcion').setValue(empresario.minoriaDescripcion);
    this.naturalForm.get('codigoCiiu').setValue(empresario.codigoCiiu);
    this.naturalForm.get('anioVentas').setValue(empresario.anioVentas);
    this.naturalForm
      .get('numeroDocumento')
      .setValue(empresario.numeroDocumento);
    this.naturalForm
      .get('idTipoDocIdentidad')
      .setValue(empresario.idTipoDocIdentidad);
    if (empresario.ventasAnuales) {
      this.naturalForm.get('valorVentas').setValue(formatPesosCop(empresario.ventasAnuales));
    } else {
      this.naturalForm.get('valorVentas').setValue(formatPesosCop(empresario.valorVentas));
    }
    this.naturalForm.get('correoElectronico').setValue(empresario.correoElectronico);
    if (empresario.tieneRut) {
      this.naturalForm.get('tieneRUT').setValue(empresario.tieneRut);
    } else {
      this.naturalForm.get('tieneRUT').setValue(empresario.tieneRUT);
    }
    this.naturalForm.get('codigoReferido').setValue(empresario.codigoReferido);
    this.naturalForm.get('idFuenteNeocredito').setValue(empresario.idFuenteNeocredito);
    this.naturalForm.get('nombreReferido').setValue(empresario.nombreReferido);
    this.naturalForm.get('otraFuente').setValue(empresario.otraFuente);
    this.naturalForm.get('numeroOpcional').setValue(+empresario.numeroOpcional);
    this.naturalForm.get('idPaisOrigen').setValue(empresario.idPaisOrigen);
    this.naturalForm.get('camaraComercioVigente').setValue(empresario.camaraComercioVigente);
    this.validarVentaAnual();
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 1000);
  }

  submit() {
    const json: PersonaNatural = this.naturalForm.value;
    json.valorVentas = parsePesosCop(this.naturalForm.get('valorVentas').value);
    json.ciiuNombre = this.ciius.find(
      (c) => c.codigoCiiu == this.naturalForm.get('codigoCiiu').value
    ).nombreCiiu;
    json.numeroDocumento = json.numeroDocumento.toLocaleUpperCase().trim();
    json.correoElectronico = json.correoElectronico.toLocaleLowerCase().trim();
    json.primerNombre = json.primerNombre.trim();
    if (json.segundoNombre != null && json.segundoNombre != '') {
      json.segundoNombre = json.segundoNombre.trim();
    }
    json.primerApellido = json.primerApellido.trim();
    if (json.segundoApellido != null && json.segundoApellido != '') {
      json.segundoApellido = json.segundoApellido.trim();
    }
    json.idFuenteNeocredito = Number(json.idFuenteNeocredito);
    json.idPaisOrigen =json.idTipoDocIdentidad != 2 ? Number(json.idPaisOrigen):'';
    json.idLocalidad = json.idLocalidad ? json.idLocalidad : null;
    this._microempresario.savePersonaNatural(json).subscribe((data: any) => {
      if (data.exitoso == "true" || data.exitoso == true) {
        this._verificacion.saveParameters({
          token: data.token,
          password: data.password,
          idUsuario: data.idUsuario,
          email: json.correoElectronico,
          tipoPersona: 'natural',
          primerNombre: json.primerNombre,
          primerApellido: json.primerApellido,
        });
        sessionStorage.setItem(
          'pre-registro',
          JSON.stringify({
            idEmpresario: data.idEmpresario,
            idEmpresarioNatural: data.idEmpresarioNatural,
            idUsuario: data.idUsuario,
            tipoPersona: 'natural',
            primerNombre: json.primerNombre,
            primerApellido: json.primerApellido,
            idTipoDocIdentidad: json.idTipoDocIdentidad,
            numeroDocumento: json.numeroDocumento,
          })
        );
        this.route.navigateByUrl('/verificacion');
      } else {
        this._sweetAlert.errorModal("Error!",true,data.error);
      }
    });
  }
  //Validaciones
  validateField(key: string) {
    return (
      (this.naturalForm.get(key).dirty || this.naturalForm.get(key)?.touched) &&
      this.naturalForm.get(key)?.invalid
    );
  }

  /** Mensaje de error para número de documento según tipo (CC/CE/PA). */
  getDocumentPatternMessage(controlName: string): string {
    const control = this.naturalForm.get(controlName);
    return getDocumentPatternMessage(control);
  }

  validateLetters(event: any) {
    const pattern = /[a-zA-Z áéíóúÁÉÍÓÚñÑ@&._$-]+/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateDocument(event: any) {
    if (
      this.naturalForm.get('idTipoDocIdentidad').value == 5 ||
      this.naturalForm.get('idTipoDocIdentidad').value == 3
    ) {
      const pattern = /[a-zA-Z0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    } else {
      this.validateNumber(event);
    }
  }

  /* onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevenir el comportamiento por defecto
      // Abrir el selectpicker
      $('#idPaisOrigen').selectpicker('toggle');
    }
  } */

  validarSelect() {
    this.naturalForm.get('numeroDocumento').setValue('');
    this.naturalForm.get('confirmNumeroDocumento').setValue(null);
    this.naturalForm.get('numeroDocumento')?.updateValueAndValidity();
    this.naturalForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
    if(this.naturalForm.get('idTipoDocIdentidad').value != 2){
      this.isPasaporte=true;
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 300);
      this.setearValidadoresForm('idPaisOrigen', [Validators.required])
    }else{
      this.isPasaporte=false;
      this.setearValidadoresForm('idPaisOrigen',null)
      this.naturalForm.get('idPaisOrigen').setValue(null);
    }
  }

  setPipeForm() {
    this.naturalForm.controls['valorVentas'].valueChanges.subscribe((data) => {
      if (data == null || data === '') {
        return;
      }
      this.naturalForm.patchValue(
        { valorVentas: formatPesosCop(data) },
        { emitEvent: false }
      );
    });
  }

  killSession() {
    sessionStorage.removeItem('pre-registro');
  }

  //Passwords
  showPassword() {
    this.isVisible = !this.isVisible;
  }

  showConfirmPassword() {
    this.isConfirm = !this.isConfirm;
  }

  showModal(title: string) {
    this.titleModal = title;
    // $('#politicasModal').modal('show');
  }

  validateForm() {
    this.markFieldsAsTouched([...this.step1Fields, ...this.step2Fields]);
    this.markConditionalFieldsTouched();
    if (this.isStep1Valid() && this.isStep2Ready() && this.guardarFuente()) {
      this.submit();
    } else {
      this._sweetAlert.errorModal("Error!",true,'Diligencia correctamente los campos obligatorios antes de continuar el proceso de registro.');
      this.selectpikerChange('codigoCiiu');
      this.selectpikerChange('idDepartamento');
      this.selectpikerChange('idCiudad');
      this.selectpikerChange('idFuenteNeocredito');
      this.selectpikerChange('idPaisOrigen');
      this.selectpikerChange('tiposContacto');
      this.selectpikerChange('idLocalidad');
    }
  }

  selectpikerChange(field: string) {
    $(`#${field}`).selectpicker('destroy');
    let valid = this.validateField(field);
    if (!valid) {
      $(`#${field}`).removeClass('is-invalid');
    } else {
      $(`#${field}`).addClass('is-invalid');
    }
    $(`#${field}`).addClass('selectpicker');
    $(`#${field}`).selectpicker('render');
  }

  validarMinoria(numero:number) {
    if (numero === 1) {
      this.setearValidadoresForm('minoriaDescripcion', [
        Validators.required,
      ]);
    } else {
      this.setearValidadoresForm('minoriaDescripcion', null);
    }
  }

  onCiudadChange() {
    this.selectpikerChange('idCiudad');
    this.validarLocalidad();
  }

  validarLocalidad() {
    if (this.naturalForm.get('idCiudad').value == this.idBogota) {
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 300);
      this.setearValidadoresForm('idLocalidad', [Validators.required])
    } else {
      this.setearValidadoresForm('idLocalidad', null)
      this.naturalForm.get('idLocalidad').setValue(null);
    }
  }

  setearValidadoresForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.naturalForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.naturalForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }
  
  validarTexto(e){
    e.target.value = this.title.transform(e.target.value);
  }

  guardarFuente():boolean{
    if(this.naturalForm.get('idFuenteNeocredito').value=='7'){      
      if(this.naturalForm.get('nombreReferido').value != '' || this.naturalForm.get('codigoReferido').value != ''){
        this.naturalForm.get('otraFuente').setValue('');
        return true;
      }else{
        this.naturalForm.get('otraFuente').setValue('');
        return false;
      }
    }else if(this.naturalForm.get('idFuenteNeocredito').value=='8'){
      this.naturalForm.get('nombreReferido').setValue('');
      this.naturalForm.get('codigoReferido').setValue('');
      return true;
    }else{
      return true;
    }   
  }

  valueSelected(valueId:any){
    this.selectpikerChange('idFuenteNeocredito');
    if(valueId == '7'){
      this.isReferido=true;
      this.isOtraFuente=false;
      this._sweetAlert.infoModal("Información",true,"Debe registrar por lo menos uno de los dos campos, ¿Quién te refirió? ó El código del referido")
      this.setearValidadoresForm('otraFuente',null);
    }else if(valueId == '8'){
      this.isOtraFuente=true;
      this.isReferido=false;
      this.setearValidadoresForm('otraFuente',[Validators.required]);
    }else{
      this.isReferido=false;
      this.isOtraFuente=false;
      this.setearValidadoresForm('otraFuente',null);
    }
  }

  validarVentaAnual(){
    const ventaMinima = formatPesosCop(this.ventasMinimas);
    if (this.naturalForm.get('valorVentas').value) {
      if (parsePesosCop(this.naturalForm.get('valorVentas').value) < this.ventasMinimas) {
        this.naturalForm.get('valorVentas').setErrors({ incorrect: true });
        this.msjErrorValorVentas = "Campo obligatorio. El monto mínimo es de " + ventaMinima + " pesos.";
      }
    }else{
      this.msjErrorValorVentas = "Campo obligatorio";
    }
  }

  selectpikerChangeContactos(field: string) {
    let valid = this.validateField(field);
    const tiposContactoElement = document.getElementById('tiposContacto');
    if (valid) {
      tiposContactoElement.classList.add('is-invalid');
    } else {
      if (tiposContactoElement.classList.contains('is-invalid')) {
        $(`#${field}`).selectpicker('destroy');
      }
      tiposContactoElement.classList.remove('is-invalid');
    }
    $(`#${field}`).selectpicker('refresh');
  }

  goToNextStep() {
    this.markFieldsAsTouched(this.step1Fields);
    this.markConditionalFieldsTouched();
    if (this.isStep1Valid()) {
      if(this.naturalForm.get('idCiudad').value == ''){
        $('#idCiudad').prop('disabled', true);
      }
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 300);      
      this.currentStep = 2;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this._sweetAlert.errorModal(
        "Error!",
        true,
        'Diligencia correctamente los campos obligatorios de Información general antes de continuar.'
      );
    }
  }

  goToPreviousStep() {
    if (this.currentStep === 1) {
      this.route.navigate(['/microempresario/registro']);
    } else {
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 300);
      this.currentStep = 1;
      window.scrollTo({ top: 0, behavior: 'smooth' });      
    }
  }

  isStep1Valid(): boolean {
    const baseValid = this.step1Fields.every((field) => this.naturalForm.get(field)?.valid);
    if (!baseValid) return false;
    if (this.isPasaporte && !this.naturalForm.get('idPaisOrigen')?.valid) return false;
    if (this.isReferido) {
      const nom = (this.naturalForm.get('nombreReferido')?.value ?? '').toString().trim();
      const cod = (this.naturalForm.get('codigoReferido')?.value ?? '').toString().trim();
      if (!nom && !cod) return false;
    }
    if (this.isOtraFuente && !this.naturalForm.get('otraFuente')?.valid) return false;
    return true;
  }

  isStep2Ready(): boolean {
    const baseValid = this.step2Fields.every((field) => this.naturalForm.get(field)?.valid);
    if (!baseValid) return false;
    if (this.naturalForm.get('idCiudad')?.value === this.idBogota && !this.naturalForm.get('idLocalidad')?.valid) return false;
    if (Number(this.naturalForm.get('minoria')?.value) === 1 && !this.naturalForm.get('minoriaDescripcion')?.valid) return false;
    return true;
  }

  private validarReferidoObligatorio(): (control: AbstractControl) => ValidationErrors | null {
    return (group: AbstractControl): ValidationErrors | null => {
      const idFuente = group.get?.('idFuenteNeocredito')?.value;
      const nombre = (group.get?.('nombreReferido')?.value ?? '').toString().trim();
      const codigo = (group.get?.('codigoReferido')?.value ?? '').toString().trim();
      const nomControl = group.get?.('nombreReferido');
      if (idFuente === '7' || idFuente === 7) {
        if (!nombre && !codigo) {
          nomControl?.setErrors({ ...nomControl?.errors, referidoRequired: true });
          return { referidoRequired: true };
        }
      }
      if (nomControl?.errors?.['referidoRequired']) {
        const err = { ...nomControl.errors };
        delete err['referidoRequired'];
        nomControl.setErrors(Object.keys(err).length ? err : null);
      }
      return null;
    };
  }

  private markFieldsAsTouched(fields: string[]) {
    fields.forEach((field) => {
      const control = this.naturalForm.get(field);
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });
    });
  }

  private markConditionalFieldsTouched() {
    if (this.isPasaporte) {
      this.naturalForm.get('idPaisOrigen')?.markAsTouched();
      this.naturalForm.get('idPaisOrigen')?.updateValueAndValidity();
    }
    if (this.isReferido) {
      this.naturalForm.get('nombreReferido')?.markAsTouched();
      this.naturalForm.get('codigoReferido')?.markAsTouched();
      this.naturalForm.updateValueAndValidity();
    }
    if (this.isOtraFuente) {
      this.naturalForm.get('otraFuente')?.markAsTouched();
      this.naturalForm.get('otraFuente')?.updateValueAndValidity();
    }
    if (Number(this.naturalForm.get('minoria')?.value) === 1) {
      this.naturalForm.get('minoriaDescripcion')?.markAsTouched();
      this.naturalForm.get('minoriaDescripcion')?.updateValueAndValidity();
    }
    if (this.naturalForm.get('idCiudad')?.value === this.idBogota) {
      this.naturalForm.get('idLocalidad')?.markAsTouched();
      this.naturalForm.get('idLocalidad')?.updateValueAndValidity();
    }
  }

  /* selectAllTiposContacto() {
    const allIds = this.listaTiposCont.map(item => item.idTipoContacto);
    this.naturalForm.get('tiposContacto').setValue(allIds);
  }

  deselectAllTiposContacto() {
    this.naturalForm.get('tiposContacto').setValue([]);
  } */

}
